import React, { useState } from "react";
import "./topicRelatedQuestionsList.scss";
import { Grid, Paper } from "@mui/material";

import NoDataAvailable from "../../components/NoDataAvailable/NoDataAvailable";
import TopicRelatedQuestionsListCard from "../TopicRelatedQuestionsListCard/TopicRelatedQuestionsListCard";

const TopicRelatedQuestionsList = ({
  topics,
  topicId,
  assessment,
  openedByAttendee,
  assessmentEvaluationStatus,
}) => {
  const [expandedId, setExpandedId] = useState(null);
  const selectedTopic = topics?.results?.find((topic) => topic?.id === topicId);

  const allQuestions = topics?.results?.flatMap(
    (topic) => topic?.evaluationQuestions?.results || []
  );
  const questionsToDisplay =
    topicId === "all"
      ? allQuestions
      : selectedTopic?.evaluationQuestions?.results;

  return (
    <Grid container className="main-container">
      <Grid item md={12} className="body-container">
        <Paper elevation={0} className="topics-question-parent-container">
          {topicId === null ? (
            <Grid container className="no-data-container">
              <NoDataAvailable
                imgHeight={4}
                imgWidth={4.5}
                message="No Topic selected"
              />
            </Grid>
          ) : !questionsToDisplay?.length ? (
            <Grid container className="no-data-container">
              <NoDataAvailable
                imgHeight={4}
                imgWidth={4.5}
                message="No Questions Available"
              />
            </Grid>
          ) : (
            questionsToDisplay?.map((question, index) => (
              <TopicRelatedQuestionsListCard
                key={index}
                question={question}
                assessment={assessment}
                expandedId={expandedId}
                setExpandedId={setExpandedId}
                topicId={topicId}
                openedByAttendee={openedByAttendee}
                assessmentEvaluationStatus={assessmentEvaluationStatus}
              />
            ))
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TopicRelatedQuestionsList;
